import {FormControl} from "@angular/forms";

export class SelectFilterUtil {
    // simple synchronous implementation of filtering
    public static initFilter(initArray, element, filterFunction, ctlName = "selectCtl", filterName = "filterCtl", resultName = "filtered") {
        if (element[ctlName] == null) {
            element[ctlName] = new FormControl();
            element[filterName] = new FormControl();
            element[resultName] = initArray != null ? [...initArray] : [];
            element[filterName].valueChanges
                .subscribe(() => {
                    SelectFilterUtil.filterMulti(initArray, element, filterFunction, filterName, resultName);
                });
        }

        // there are circular references inside control elements so they must be excluded from saving into JSON
        // with this code we bind a new function to the toJSON function of element, which will be called when
        // JSON.stringify is called with this object
        element.toJSON = function () {
            let result = {}; // initialize a new object
            for (let enumerableProperty in this) {
                if (enumerableProperty !== ctlName && enumerableProperty !== filterName) {
                    result[enumerableProperty] = this[enumerableProperty];
                }
            }
            return result;
        };
    }

    public static filterMulti(initArray, element, filterFunction, filterName, resultName) {
        if (!initArray) {
            return;
        }
        // get the search keyword
        let search = element[filterName].value;
        if (!search) {
            element[resultName] = [...initArray];
            return;
        } else {
            search = search.toLowerCase();
        }
        // filter the rights
        element[resultName] = initArray.filter((element) => { return filterFunction(element, search) });
    }

    public static clearFilter(element, ctlName = "selectCtl", filterName = "filterCtl", resultName = "filtered") {
        // element[ctlName] = null;
        // element[filterName] = null;
        // element[resultName] = [];
    }
}